import { useEffect } from 'react';
import { PanelButtons } from '../panels/PanelButtons';
import { GenericEditProps } from './Edit';
import { EventSections } from '../../../lib/events/EventLogger';
import { P2GText, P2GGrid } from '@parcel2go/core-ui';
import CommonRuleSummary from './rules/CommonRuleSummary';
import { useAnalytics } from '@parcel2go/npm-p2g-app';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

export default function ItemRules(props: GenericEditProps) {
  const { track } = useAnalytics();

  useEffect(
    () =>
      track({
        type: 'edit_item_loaded',
        payload: {
          ...GenerateBaseAnalyticsPayload([EventSections.SmartSend, 'order-details-panel']),
          action: props.editType
        }
      }),
    [props.editType]
  );

  return (
    <P2GGrid container spacing={2} direction="column">
      <P2GGrid item>
        <P2GText variant="body2">Manage the automation of your imports, powered by Rule Manager.</P2GText>
      </P2GGrid>
      <P2GGrid item>
        <CommonRuleSummary
          limitToSelection={false}
          item={props.item}
          sections={[EventSections.SmartSend, 'order-details-panel']}
        />
      </P2GGrid>
      <P2GGrid item>
        <PanelButtons onCancel={props.onClose} />
      </P2GGrid>
    </P2GGrid>
  );
}
